import api from '../index';

const baseUrl = '/inspection';

export const searchCustomerAndVehicleApi = (data) => {
  return api({
    method: 'get',
    url: `${baseUrl}/search?key=${data.key}&type=${data.type}`,
  });
};

export const partsSeedDataApi = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/inspection-seed-data`,
  });
};

export const getInspectionListings = () => {
  return api({
    method: 'get',
    url: `${baseUrl}/list`,
  });
};

export const addApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/save-inspection`,
    data,
  });
};

export const updateApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update`,
    data,
  });
};

export const deleteInspTempApi = (id) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete-inspection-template/${id}`,
  });
};

export const getInspectionApi = (id) => {
  return api({
    method: 'post',
    url: `${baseUrl}/specific-inspection`,
    data: id,
  });
};

export const deleteInspectionApi = (data) => {
  return api({
    method: 'delete',
    url: `${baseUrl}/delete`,
    data,
  });
};

export const getCustomTemplatesApi = (data) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-custom-templates`,
    data,
  });
};

export const createCustomTemplateApi = (data) => {
  return api({
    method: 'post',
    url: `${baseUrl}/create-custom-template`,
    data,
  });
};

export const updateCustomTemplateApi = (data) => {
  return api({
    method: 'put',
    url: `${baseUrl}/update-custom-template`,
    data,
  });
};

export const getErrorCodeDetailsApi = (id) => {
  return api({
    method: 'get',
    url: `${baseUrl}/get-code-details/${id}`,
  });
};

export const deletePhotoApi = (path) => {
  return api({
    method: 'post',
    url: `${baseUrl}/delete-photo`,
    data: { path },
  });
};
